import { render, staticRenderFns } from "./OverMaxSize.vue?vue&type=template&id=72065f06&scoped=true"
import script from "./OverMaxSize.vue?vue&type=script&lang=js"
export * from "./OverMaxSize.vue?vue&type=script&lang=js"
import style0 from "./OverMaxSize.vue?vue&type=style&index=0&id=72065f06&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72065f06",
  null
  
)

export default component.exports